import Button from 'app/shared/components/button/Button';
import styled from 'styled-components/macro';
import styledFuncs from 'app/styles/styledFuncs';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import { useGetAddresses } from 'app/core/api/user/api-user';
import { useWatchAsRef } from 'app/tools/hooks/misc-hooks';
import { useEffect, useState } from 'react';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import { DeliveryLocations } from 'app/core/api/user/api-user.types';
import { SelectorSvg } from 'app/shared/components/icon/icon-lib';
import QuoteNewAddress from './quote-new-address';

type Props = {
  setIsShowPaymentOption: (isVisible: boolean) => unknown;
  setDeliveryLocation: (deliveryLocation: number) => unknown;
  deliveryLocation: number;
};
export default function QuoteAddress({
  setIsShowPaymentOption,
  setDeliveryLocation,
  deliveryLocation,
}: Props): JSX.Element {
  const CardContainer = styled.div`
    background: #31ad31;
    border-radius: 10px;
    position: relative;
    height: ${styledFuncs.pad(9.6)};
    padding: ${styledFuncs.pad(1.5)};
    span {
      margin-bottom: ${styledFuncs.pad(1)};
      color: white;
      weight: bold;
    }
  `;
  const CardHolder = styled.div`
    position: absolute;
    left: 10px;
    right: 10px;
    top: ${styledFuncs.pad(5.8)};
  `;
  const Card = styled.div`
    background: white;
    border-radius: 10px;
    min-height: ${styledFuncs.pad(5.8)};
    padding: ${styledFuncs.pad(1)};
    margin-bottom: ${styledFuncs.pad(2)};
    filter: drop-shadow(0px 3px 10px rgba(0, 0, 0, 0.161));
    span {
      color: #31ad31;
      weight: bold;
    }
  `;
  const {
    resource: addresslist,
    loading,
    loadingMissing,
    request,
  } = useGetAddresses();
  const loadingRef = useWatchAsRef(loading);
  const titleMsg = loadingMissing ? 'Loading...' : `Card List`;
  const [showAddCard, setShowAddCard] = useState(false);
  useEffect(() => {
    if (!loadingRef.current) request();
  }, [loadingRef, request, showAddCard]);
  useSetPageTitle(titleMsg);
  return (
    <div style={{ display: 'block', margin: '0 auto' }}>
      <QuoteNewAddress
        showAddCard={showAddCard}
        setShowAddCard={setShowAddCard}
      />
      <div>
        <CardContainer>
          <span>Confirm your address</span>
          <CardHolder>
            {addresslist &&
              addresslist.map((addressdetail: DeliveryLocations) => (
                <Card
                  key={addressdetail.id}
                  onClick={() =>
                    setDeliveryLocation(addressdetail.id ?? 0)
                  }
                  style={{ display: 'flex' }}
                >
                  <div style={{ flexGrow: 2 }}>
                    <span color="textPrimary">
                      {addressdetail.userDisplayLocationName}
                    </span>
                    <br />
                    <span style={{ color: 'black' }}>
                      {addressdetail.addrLine1}, {addressdetail.city},{' '}
                      {addressdetail.country},{' '}
                      {addressdetail.postcode}
                    </span>
                  </div>
                  {deliveryLocation === addressdetail.id && (
                    <div
                      style={{
                        flexGrow: 1,
                        paddingTop: '10px',
                        paddingRight: '10px',
                        textAlign: 'right',
                      }}
                    >
                      <SelectorSvg />
                    </div>
                  )}
                </Card>
              ))}
            <Card>
              <button
                onClick={() => setShowAddCard(true)}
                type="button"
                style={{
                  background: 'none',
                  color: 'inherit',
                  border: 'none',
                  padding: 0,
                  font: 'inherit',
                  cursor: 'pointer',
                  outline: 'inherit',
                }}
              >
                <SpeedDialIcon /> Add Another Address
              </button>
            </Card>
            <Button
              style={{ width: '100%', marginBottom: '20px' }}
              fullWidth
              onClick={() => setIsShowPaymentOption(true)}
              disabled={deliveryLocation === 0}
            >
              Accept
            </Button>
          </CardHolder>
        </CardContainer>
      </div>
    </div>
  );
}
